module.exports = __webpack_public_path__ + "static/media/linkedin_icon.5178c291.png";